import { ArdoqId } from '@ardoq/api-types';
import { isTruthy } from '@ardoq/common-helpers';
import { ComponentItemDataById } from '../types';

export const getSourceWorkspaceIds = (
  sourceComponentItemDataById: ComponentItemDataById
): ArdoqId[] =>
  Array.from(
    new Set(
      Object.values(sourceComponentItemDataById)
        .map(({ workspaceId }) => workspaceId)
        .filter(isTruthy)
    )
  );

export const getSelectedReferenceTypeNameByComponentId = (
  sourceComponentItemDataById: ComponentItemDataById,
  referenceTypeNameByWorkspaceId: Record<ArdoqId, string | null>
): Record<ArdoqId, string | null> =>
  Object.fromEntries(
    Object.entries(sourceComponentItemDataById).map(
      ([componentId, { workspaceId }]) => [
        componentId,
        workspaceId
          ? (referenceTypeNameByWorkspaceId[workspaceId] ?? null)
          : null,
      ]
    )
  );
